<template>
    <div class="monaco-editor">
        <div class="monaco-container" ref="container"></div>
        <!-- Doesn't seems to work -->
<!--        <b-btn @click="editor.getAction('editor.action.formatDocument').run()">Auto Format</b-btn>-->
    </div>
</template>

<script>
export default {
    name: 'monaco-editor',
    props: {
        value: { type: String, default: '' },
        lang: { type: String, default: 'liquid' },
        options: { type: Object, default: () => ({}) },
        lineNumbers: { type: Boolean },
        item: { type: Object },
        component: { type: Object },
        block: { type: Object }
    },
    data() {
        return {
            monaco: null,
            editor: null,
            model: null
        };
    },
    async mounted() {
        const monaco = await import('monaco-editor');
        this.monaco = monaco;

        this.editor = monaco.editor.create(this.$refs.container, {
            value: this.value,
            language: this.lang,
            automaticLayout: true,
            minimap: { enabled: false },
            // wordWrap: 'on',
            folding: false,
            lineNumbers: this.lineNumbers,
            scrollBeyondLastLine: false,
            theme: 'vs',
            tabSize: 2,
            insertSpaces: true,
            autoIndent: true,
            ...this.options
        });

        this.editor.onDidChangeModelContent(() => {
            const nextValue = this.editor.getValue();
            if (nextValue !== this.value) {
                this.$emit('input', nextValue);
                this.$emit('change', nextValue);
            }
        });

        let completion = [];
        this.addCompletion(completion, this.item, `item`);
        this.addCompletion(completion, this.block, `block`);
        this.addCompletion(completion, this.component, `component`);
        this.addCompletion(completion, this.cmsPage, `page`);
        this.addCompletion(completion, this.cmsWebsite, `website`);

        if (this.lang === `liquid`) {
            completion.push({
                label: 'if',
                kind: monaco.languages.CompletionItemKind.Snippet,
                insertText: '{% if ${1:condition} %}\n  $0\n{% endif %}',
                insertTextRules:
                monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet
            });

            console.log(completion);

            monaco.languages.registerCompletionItemProvider('liquid', {
                provideCompletionItems() {
                    return {
                        suggestions: completion
                            // [
                            // {
                            //     label: 'item',
                            //     kind: monaco.languages.CompletionItemKind.Variable,
                            //     insertText: 'item'
                            // },
                            // {
                            //     label: 'block',
                            //     kind: monaco.languages.CompletionItemKind.Variable,
                            //     insertText: 'block'
                            // },
                            // {
                            //     label: 'component',
                            //     kind: monaco.languages.CompletionItemKind.Variable,
                            //     insertText: 'component'
                            // },
                            // {
                            //     label: 'page',
                            //     kind: monaco.languages.CompletionItemKind.Variable,
                            //     insertText: 'page'
                            // },
                            // {
                            //     label: 'website',
                            //     kind: monaco.languages.CompletionItemKind.Variable,
                            //     insertText: 'website'
                            // },

                        // ]
                    };
                }
            });
        } else {
            monaco.languages.registerCompletionItemProvider(this.lang, {
                provideCompletionItems() {
                    return {
                        suggestions: completion
                    };
                }
            })
        }
    },
    methods: {
        addCompletion(completion, obj, name) {
            if (!obj)
                return;
            const keys = Object.keys(obj);
            for (let key of keys) {
                completion.push({
                    label: `${name}.${key}`,
                    kind: this.monaco.languages.CompletionItemKind.Variable,
                    insertText: `${name}.${key}`
                });
            }
        }
    },
    watch: {
        value(next) {
            if (!this.editor) return;
            const current = this.editor.getValue();
            if (next !== current) {
                this.editor.setValue(next || '');
            }
        }
    },
    beforeDestroy() {
        // if (this.model) this.model.dispose();
        if (this.editor) this.editor.dispose();
    }
};
</script>

<style scoped>
.monaco-editor {
    width: 100%;

    .monaco-container {
        width: 100%;
        height: 400px;
        border: 1px solid #ddd;
    }
}
</style>
